import {PureComponent} from 'react';

const Label = ({id, name, checked, onChange, onClick}) => (
    <label onClick={onClick}>
        <input
            className="form-element"
            type="checkbox"
            name="interests"
            value={id}
            checked={checked}
            onChange={onChange}
        />
        <span>{name}</span>
    </label>
);

class LabelWrapper extends PureComponent {

    constructor(props) {
        super(props);

        this.handle = this.handle.bind(this);
    }

    render() {
        return (
            <Label
                {...this.props}
                onChange={this.handle}
                onClick={this.handle}
            />
        );
    }

    handle() {
        const {id, checked, onChange} = this.props;

        return onChange(id, !checked);
    }

}

export default LabelWrapper;
